import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

type SelectedProps = {
  selected?: boolean;
};

type ShowProps = {
  show?: boolean;
};

export const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const ButtonToggle = styled.button`
  border: none;
  outline: none !important;
  border-radius: 6px;
  font-size: 0.75rem;
  background: transparent;
  padding: 0;

  flex: 1;
  display: flex;
  flex-direction: column;

  svg {
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const ButtonToggleContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
`;

export const ContentIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Line = styled.div`
  height: 16px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
`;

export const ButtonAddUnit = styled(Link)`
  border: none;
  outline: none !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${({ theme }) => theme.colors.blueClean};
  color: ${({ theme }) => theme.colors.blue};
  padding: 10px;

  & svg {
    margin-right: 5px;
  }
`;

export const ContentUpper = styled.div<ShowProps>`
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: white;
  position: absolute;
  width: 100%;
  top: 55px;
  z-index: 9;
`;

export const ContentOthersUnits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 10px;
`;

export const HrCustom = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 10px;
`;

export const ContentUnits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
`;

export const UnitTitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-family: "Mangueira bold";
  font-size: 12px;
  padding: 10px 10px 0;
`;

export const UnitSubtitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 10px;
  padding: 0 10px 10px;
`;

export const UnitOldResident = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? "#e7eaff" : "#828282")};
  color: ${({ theme, selected }) => (selected ? theme?.colors?.blue : "#fff")};
  padding: 3px;
  width: 100%;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  font-size: 10px;
  font-weight: 700;
`;

export const ContentUnit = styled.div<SelectedProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.blue : "#efefef"};
  color: ${({ theme, selected }) => (selected ? "#fff" : theme.colors.gray)};
  border-radius: 3px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue};
    color: #fff;

    ${UnitOldResident} {
      background-color: #e7eaff;
      color: ${({ theme }) => theme?.colors?.blue};
    }
  }
`;

export const TitleOthersUnits = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
  font-family: "Mangueira bold";
`;

export const TitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-family: "Mangueira bold";
  font-size: 12px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const SubtitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const AddressInButton = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
`;

export const OldResident = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dadada;
  color: #7a7a7a;
  padding: 3px;
  width: calc(100% - 20px);
  border-radius: 8px;
  margin: 0 10px 5px;
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  div {
    display: flex;
    place-content: space-between;

    div {
      display: flex;
      flex-direction: column;

      h2 {
        margin: 0;
        color: ${({ theme }) => theme.colors.blue};
        font-size: 16px;
      }

      span {
        color: #7a7a7a;
        font-size: 14px;
      }
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.blue};
    cursor: pointer;
    margin-left: 10px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentRadio = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LineHorizontal = styled.div`
  width: 100%;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  margin: 12px 0;
`;

export const ContentForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContentItens = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 255px;
  height: 255px;
  overflow-y: scroll;
`;

interface IContentItem {
  isDisabled: boolean;
}

export const ContentItem = styled.div<IContentItem>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;

  ${({ isDisabled }) => {
    if (isDisabled) {
      return css`
        background: #efefef;
      `;
    }

    return css`
      border: 1px solid #efefef;
    `;
  }}
`;

export const TextNotFound = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 16px;
  text-align: center;
`;

export const ContentItemLine = styled.div`
  height: 25px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
`;

export const ContentItemLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ContentItemLabelTitle = styled.span`
  color: #828282;
  font-size: 12px;
  font-weight: 600;
`;

export const ContentItemLabelSubtitle = styled.span`
  color: #828282;
  font-size: 10px;
`;

export const ContentButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  & > button {
    min-width: 162px;
  }
`;
